export enum ENavegacaoRegistro {
    Primeiro = 1,
    Anterior = 2,
    Proximo = 3,
    Ultimo = 4
}
